// extracted by mini-css-extract-plugin
export default {"navBar":"navBar_navBar__5ZNVC","totalItem":"navBar_totalItem__58b-H"};